import React, { useContext } from "react";
import styles from "./Services.module.scss";
import { Context } from "../../Store";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay } from "swiper";
const Slider = () => {
  let { servicesRes, dir } = useContext(Context);

  // const servicesResFilter = servicesRes.filter(
  //   (service) => service.status === 1
  // );
  return (
    <>
      {servicesRes && (
        <Swiper
          dir={dir}
          slidesPerView={1}
          spaceBetween={120}
          slidesPerGroup={1}
          loop={true}
          loopFillGroupWithBlank={false}
          modules={[Autoplay]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
        >
          {servicesRes?.map((service) => (
            <SwiperSlide key={service.id}>
              <div className={styles.item}>
                <img src={service?.logo} alt="" />
                <h2>{service?.name}</h2>
                <p>{service?.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
};

export default Slider;
